// 性别
export default () => ['男', '女', '其他']



// WEBPACK FOOTER //
// ./src/constants/genders.js